/**
 * @generated SignedSource<<8dab8b19c64417835644c43dc8b2f4a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsCustomFields_viewer$data = {
  readonly actualPersonId: string | null;
  readonly id: string;
  readonly company: {
    readonly " $fragmentSpreads": FragmentRefs<"CustomFieldTable_company">;
  } | null;
  readonly " $fragmentType": "SettingsCustomFields_viewer";
};
export type SettingsCustomFields_viewer$key = {
  readonly " $data"?: SettingsCustomFields_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsCustomFields_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsCustomFields_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CustomFieldTable_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c736e7c80c524ca02ee699ac0a546d30";

export default node;
